import React from 'react';

import {ErrorState} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {StyledContainer} from './styles';
import {DistrictErrorStateProps} from './types';

const {pleaseTryAgain} = translations['pt-br'].commons;

export function DistrictErrorState({handleRefresh, errorTitle, children}: DistrictErrorStateProps) {
	return (
		<StyledContainer>
			<ErrorState
				title={errorTitle}
				description={pleaseTryAgain}
				handleRefresh={handleRefresh}>
				{children}
			</ErrorState>
		</StyledContainer>
	);
}
